import { render, staticRenderFns } from "./NewCustomerView.vue?vue&type=template&id=166f4b26&"
import script from "./NewCustomerView.vue?vue&type=script&lang=js&"
export * from "./NewCustomerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports